import { inputClass } from './ui/inputClass';
import type { SpotResponse } from '../types/api';

interface Props {
  spots: SpotResponse[];
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export function SpotSelect({ spots, value, onChange, disabled }: Props) {
  return (
    <select
      className={inputClass}
      value={value}
      onChange={e => onChange(e.target.value)}
      disabled={disabled}
    >
      <option value="">— Choose a spot —</option>
      {spots.map(s => (
        <option key={s.id} value={s.id}>{s.name}</option>
      ))}
    </select>
  );
}
